'use es6';

import getPropertyValues from './getPropertyValues';
export default ((property, dataset) => {
  return getPropertyValues(property, dataset).map(value => value.raw).toSet().filter(value => !!value);
});